// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .border {
    border-top: 1px solid ${(props) => props.theme.colors.BORDER.BLUE};
  }
  .remember-me-text {
    ${(props) =>
      props.variation === 'checkout'
        ? `font-weight:bold;font-size:${props.theme.typography.fontSizes.fs14};`
        : ''}
  }
  .save-my-plcc {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .richTextColor a {
    color: ${(props) => props.theme.colorPalette.red[500]};
  }
  .remember-me-sub-text {
    ${(props) =>
      props.variation === 'checkout'
        ? `font-size:${props.theme.typography.fontSizes.fs12};`
        : 'display: block;'}
  }
  .login-button-test-class {
    ${(props) =>
      props.variation === 'checkout'
        ? `background:${props.theme.colorPalette.blue.C900};color:${props.theme.colorPalette.white}`
        : 'display: block;'}
  }
  .rightAlignedContent {
    width: 50px;
  }
  .login-button-enlarge {
    width: 100%;
  }
`;
export const customSpinnerStyle = css`
  .spinner-overlay {
    position: absolute;
  }
`;
export default styles;
